import { useEffect, useState } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Col, Row } from 'react-bootstrap';
import { Dropdown } from 'primereact/dropdown';
import DriverEditDialog from './DriverEditDialog/DriverEditDialog';

function DriversDataTable() {

  // #region const and vars

  const [drivers, setDrives] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editDialogIsVisible, setEditDialogIsVisible] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [globalFilter, setGlobalFilter] = useState('');
  const activeTypes = [{ label: 'Activo', value: true }, { label: 'Inactivo', value: false }]
  const [filters, setFilters] = useState({
    'global': {
      value: null,
      matchMode: FilterMatchMode.CONTAINS
    },
    "firstName": {
      operator: FilterOperator.AND,
      constraints: [{
        value: null,
        matchMode:
          FilterMatchMode.CONTAINS
      }]
    },
    "lastName": {
      operator: FilterOperator.AND,
      constraints: [{
        value: null,
        matchMode:
          FilterMatchMode.CONTAINS
      }]
    },
    "phoneNumber": {
      operator: FilterOperator.AND,
      constraints: [{
        value: null,
        matchMode:
          FilterMatchMode.CONTAINS
      }]
    },
    "active": {
      operator: FilterOperator.OR,
      constraints: [{
        value: null,
        matchMode:
          FilterMatchMode.EQUALS
      }]
    }      
  });

  // #endregion 

  // #region methods

  const getDrivers = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/driver/findAll`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setDrives(data.responseObject);
        } else {
          console.warn('DriversDataTable: getDrivers: error: data:', data);
        }
        setLoading(false);
      });
  };

  // #endregion 

  // #region events

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    const _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilter(value);
  }

  const onNewClick = () => {
    setSelectedDriver(null);
    setEditDialogIsVisible(true);
  };

  const onDriverSaved = () => {
    setEditDialogIsVisible(false);
    getDrivers();
  };

  const onEditClick = (user) => {
    setSelectedDriver(user);
    setEditDialogIsVisible(true);
  };

  // #endregion

  // #region templates

  const headerTemplate = (
    <>
      <Row>
        <Col md={8}>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText
              placeholder="Filtrar"
              value={globalFilter}
              onChange={onGlobalFilterChange} />
          </span>
        </Col>
        <Col md={4}>
          <Button
            label="Nuevo"
            className="p-button-raised p-button-sm float-end"
            onClick={onNewClick}
          />
        </Col>
      </Row>
    </>
  );

  const dataTableActionsTemplate = (profile) => {
    return (
      <>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-primary p-button-text mr-2"
          onClick={() => onEditClick(profile)} />
      </>
    );
  };

  const activeFieldTemplate = (vehicle) => {
    return (
      vehicle.active ? <i className="pi pi-check text-primary"></i> : <></>
    );
  }

  const activeTypeFilterTemplate = (option) => {
    return <span>{option.label}</span>;
  };

  const activeTypesFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={activeTypes}
        onChange={(e) => options.filterCallback(e.value)}
        itemTemplate={activeTypeFilterTemplate}
        placeholder="Selecciona el estatus activo"
        showClear />
    );
  };
  
  const dataTableTemplate = (
    <>
      <div className="card">
        <DataTable
          className=""
          showGridlines
          stripedRows
          size="small"
          responsiveLayout="scroll"
          emptyMessage="No se encontraron choferes"
          value={drivers}
          header={headerTemplate}
          filters={filters}
          filterDisplay="menu"
          loading={loading}
          globalFilterFields={[          
            'firstName',
            'lastName',
            'phoneNumber',
            "active"
          ]}>
          <Column
            className='app-w-50-px text-center'
            body={dataTableActionsTemplate}
            exportable={false} />
          <Column
            field="firstName"
            header="Nombres"
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por nombres"
            sortable />
          <Column
            field="lastName"
            header="Apellidos"
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por apellidos"
            sortable />
          <Column
            field="phoneNumber"
            header="Número telefónico"
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por número telefónico"
            sortable />
          <Column
            field="active"
            header="Activo"
            className='app-w-200-px text-center'
            filter
            filterPlaceholder="Buscar por Activo"
            filterElement={activeTypesFilterTemplate}
            body={activeFieldTemplate}
            sortable />
        </DataTable>
      </div>
    </>
  );

  // #endregion

  useEffect(() => {
    getDrivers();
  }, []);

  return (
    <>
      <article>
        {dataTableTemplate}
        <DriverEditDialog
          visible={editDialogIsVisible}
          onHide={() => setEditDialogIsVisible(false)}
          onDriverSaved={onDriverSaved}
          driver={selectedDriver}
        />
      </article>
    </>
  );
}

export default DriversDataTable;